import { ActionMenu, Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import type { ProxyOnButtonGroupProps } from '../types';
import styles from '../InvoiceReportsButtonGroup.module.scss';

const cx = classnames.bind(styles);

/** Proxy ON: Import + AI OCR + Create new as dropdowns. All menu/button data from parent (useProxyOnButtonGroupItems). */
export const ProxyOnButtonGroup: FC<ProxyOnButtonGroupProps> = memo(
  ({
    importMenuItems,
    importButtonProps,
    aiOcrBulkItems,
    aiOcrButtonProps,
    createNewItems,
    createNewButtonProps,
    noPayeeTooltip,
  }) => (
    <>
      <Tooltip title={noPayeeTooltip}>
        <span>
          <ActionMenu
            type='button'
            items={importMenuItems}
            buttonProps={importButtonProps}
            className={cx('actionMenu')}
          />
        </span>
      </Tooltip>
      <Tooltip title={noPayeeTooltip}>
        <span>
          <ActionMenu
            type='button'
            items={aiOcrBulkItems}
            buttonProps={aiOcrButtonProps}
            className={cx('actionMenu')}
          />
        </span>
      </Tooltip>
      <Tooltip title={noPayeeTooltip}>
        <span>
          <ActionMenu
            type='button'
            items={createNewItems}
            buttonProps={createNewButtonProps}
            className={cx('actionMenu')}
          />
        </span>
      </Tooltip>
    </>
  )
);

ProxyOnButtonGroup.displayName = 'ProxyOnButtonGroup';
